var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"th has-text-centered mg-t-35"},[_c('h3',{staticClass:"is-size-5 has-text-weight-normal"},[_vm._v("** ระบบอยู่ระหว่างการพัฒนา **")])])
}]

export { render, staticRenderFns }